import { render, staticRenderFns } from "./DialogChapter.vue?vue&type=template&id=3cc3c57a&scoped=true"
import script from "./DialogChapter.vue?vue&type=script&lang=js"
export * from "./DialogChapter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc3c57a",
  null
  
)

export default component.exports